import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant switch
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent extends BaseComponent implements OnInit {
    @Input() checked: boolean = false;
    @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Emit
     */
    emit() {
        this.change.emit(this.checked);
    }
}
